import React from 'react'

const SearchMessageSidebarComponent = () => {
    return <React.Fragment>

    </React.Fragment>
}

export default SearchMessageSidebarComponent